import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class DataLayerService {
	constructor() {
		// Ensure the dataLayer array exists
		(window as any).dataLayer = (window as any).dataLayer || [];
	}

	pushEvent(eventData: any): void {
		(window as any).dataLayer.push(eventData);
	}
}